
    import "src/shared/components/Catalog/utils.module.scss?farm_css_modules";
    
    export default {"exportBtn": `exportBtn-125ddf46`,"flexCenter": `flexCenter-125ddf46`,"searchContainer": `searchContainer-125ddf46`,"searchInput": `searchInput-125ddf46`,"topFilter": `topFilter-125ddf46`,"topLeftFilter": `topLeftFilter-125ddf46`,"topRightFilter": `topRightFilter-125ddf46`}
    